import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const useValidatorsIf = (
  predicate: (control: AbstractControl) => boolean,
  validators: ValidatorFn | ValidatorFn[],
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!predicate(control)) {
      return null;
    }

    if (!Array.isArray(validators)) {
      return validators(control);
    }

    for (const validator of validators) {
      const result = validator(control);
      if (result) {
        return result;
      }
    }
    return null;
  };
};
